'use client'

import { useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import { gsap } from 'gsap'

Modal.setAppElement('body')

export default function SlideMenuModal({
  open,
  id,
  contentLabel,
  onRequestClose,
  children,
  panelClassName = 'overflow-hidden w-full xl:w-[40%] h-screen translate-x-full opacity-0',
}) {
  const [startAnimation, setStartAnimation] = useState(false)
  const [finishOpen, setFinishOpen] = useState(false)
  const menuRef = useRef(null)

  useEffect(() => {
    if (!open) {
      setStartAnimation(false)
      setFinishOpen(false)
    }

    const timeout = setTimeout(() => {
      if (open) {
        setFinishOpen(true)
      }
    }, 500)

    return () => clearTimeout(timeout)
  }, [open])

  useEffect(() => {
    if (!menuRef.current) return

    if (finishOpen) {
      gsap.fromTo(
        menuRef.current,
        { x: '100%', opacity: 0 },
        { x: '0%', opacity: 1, duration: 0.8, ease: 'power3.out' },
      )
    } else {
      gsap.to(menuRef.current, { x: '100%', opacity: 0, duration: 0.6, ease: 'power3.in' })
    }
  }, [finishOpen])

  return (
    <Modal
      isOpen={open}
      id={id}
      style={{
        content: {
          border: 0,
          inset: 0,
          padding: 0,
          margin: 0,
          width: '100%',
          height: '100%',
          overflow: 'visible',
          background: 'transparent',
        },
        overlay: {
          zIndex: 1000,
          width: '100%',
          background: startAnimation ? '#2F2F2F4D' : 'transparent',
          backdropFilter: startAnimation ? 'blur(13.6px)' : 'none',
          transition: open
            ? 'background 0.3s ease-in-out, backdrop-filter 0.3s ease-in-out'
            : 'background 0.3s ease-in-out 0.5s, backdrop-filter 0.3s ease-in-out 0.5s',
        },
      }}
      closeTimeoutMS={1000}
      contentLabel={contentLabel}
      onRequestClose={onRequestClose}
      onAfterOpen={() => setStartAnimation(true)}
      onAfterClose={() => setStartAnimation(false)}
    >
      <div className="w-full flex justify-end">
        <div ref={menuRef} className={panelClassName}>
          {children}
        </div>
      </div>
    </Modal>
  )
}
